import { AppBar, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logoBlack from "@images/logos/logoBlack.png";
import logoWhite from "@images/logos/logoWhite.png";
import "./AppNavbar.scss";
import MobileNavDrawer from "./MobileNavDrawer";
import {
  LOGO_TEXT,
  NAV_ITEMS,
  SCROLL_THRESHOLD,
  SOCIAL_ITEMS,
} from "./navbar-config";

interface Props {
  transparentNavbar?: boolean;
  /** Override the dark (solid state) logo. Defaults to logoBlack.png. */
  logoDark?: string;
  /** Override the light (transparent state) logo. Defaults to logoWhite.png. */
  logoLight?: string;
}

const AppNavbar = ({
  transparentNavbar = true,
  logoDark = logoBlack,
  logoLight = logoWhite,
}: Props) => {
  const [isTransparent, setIsTransparent] = useState(
    transparentNavbar && window.scrollY < SCROLL_THRESHOLD,
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    if (!transparentNavbar) return;
    const handleScroll = () =>
      setIsTransparent(window.scrollY < SCROLL_THRESHOLD);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [transparentNavbar]);

  const navbarClass = ["app-navbar", !isTransparent && "solid-nav"]
    .filter(Boolean)
    .join(" ");

  return (
    <AppBar className={navbarClass}>
      <div className="flex">
        <Link to="/" className="logo-link">
          <img
            src={isTransparent ? logoLight : logoDark}
            alt="Logo"
            className="navbar-logo"
          />
          <span className="logo-text">{LOGO_TEXT}</span>
        </Link>
        <div className="nav-link-container flex">
          {NAV_ITEMS.map(({ label, href }) => (
            <Link key={href} to={href} className="nav-link">
              {label}
            </Link>
          ))}
          <div className="nav-social-links-container">
            {SOCIAL_ITEMS.map(({ href, iconClass, label }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="nav-social-link"
                aria-label={label}
              >
                <i className={`${iconClass} fa-xl social-icon`}></i>
              </a>
            ))}
          </div>
        </div>
        <div className="nav-drawer-toggle">
          <IconButton
            size="medium"
            className="nav-drawer-toggle-button"
            onClick={() => setIsDrawerOpen(true)}
          >
            <i className="fa-solid fa-xl fa-bars"></i>
          </IconButton>
          <MobileNavDrawer
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
        </div>
      </div>
    </AppBar>
  );
};

export default AppNavbar;
